const kGoldInGiftCard = require('@/assets/images/activities/fission/icon/kgold.png') // 奖品卡片上的K币图标
const couponInGiftCard = require(`@/assets/images/activities/fission/icon/coupon.png`) // 奖品卡片上的优惠券图标
const progressBarCoupon = require('@/assets/images/activities/fission/icon/award__coupon.png') // 进度条区域优惠券图标

export const styleInfo = {
  common: {
    icon: {
      kGold: require('@/assets/images/activities/fission/icon/kgold.png'),
    },
  },
  'mobile-legends': {
    color: {
      fissionBg: 'rgba(49, 62, 99, 1)',
      rulesBg: 'rgba(21, 26, 45, 1)',
    },
    icon: {
      popoverCoupon: require('@/assets/images/activities/fission/mobile-legends/popover-coupon-icon.png'),
      progressBarCoupon,
      kGoldInGiftCard,
      couponInGiftCard,
    },
  },
  pubgm: {
    color: {
      fissionBg: 'rgba(33, 40, 46, 1)',
      rulesBg: 'rgba(33, 40, 46, 1)',
    },
    icon: {
      popoverCoupon: require('@/assets/images/activities/fission/pubgm/popover-coupon-icon.png'),
      progressBarCoupon,
      kGoldInGiftCard,
      couponInGiftCard,
    },
  },
  genshin: {
    color: {
      fissionBg: 'rgba(127, 135, 161, 1)',
      rulesBg: 'rgba(127, 135, 161, 1)',
    },
    icon: {
      popoverCoupon: require('@/assets/images/activities/fission/pubgm/popover-coupon-icon.png'),
      progressBarCoupon,
      kGoldInGiftCard: require('@/assets/images/activities/fission/genshin/kGold.png'),
      couponInGiftCard: require('@/assets/images/activities/fission/genshin/coupon.png'),
    },
  },
}
